export default "/images/vopay.svg?5ffc54f3ce167265bb6494bf37299360";